export const card = { background: "#fff", border: "1px solid #E2E8F0", borderRadius: 14, padding: 18 };
const lab = { display: "flex", flexDirection: "column", gap: 4, fontSize: 11.5, fontWeight: 700, color: "#475569", letterSpacing: ".02em" };
const box = { border: "1px solid #CBD5E1", borderRadius: 8, padding: "8px 10px", fontSize: 13.5, fontFamily: "inherit", background: "#fff", width: "100%" };

export const Num = ({ label, value, onChange, testid, step = "any", min = 0, suffix }) => (
  <label style={lab}>{label}{suffix && <span style={{ fontWeight: 500, color: "#94a3b8" }}> ({suffix})</span>}
    <input data-testid={testid} type="number" step={step} min={min} value={value} onChange={e => onChange(e.target.value === "" ? "" : Number(e.target.value))} style={box}/>
  </label>
);

export const Pick = ({ label, value, onChange, options, testid }) => (
  <label style={lab}>{label}
    <select data-testid={testid} value={value} onChange={e => onChange(e.target.value)} style={box}>
      {options.map(o => Array.isArray(o) ? <option key={o[0]} value={o[0]}>{o[1]}</option> : <option key={o}>{o}</option>)}
    </select>
  </label>
);

export const Grid = ({ children, min = 150 }) => <div style={{ display: "grid", gridTemplateColumns: `repeat(auto-fit, minmax(${min}px, 1fr))`, gap: 12 }}>{children}</div>;

export const Result = ({ label, value, testid, big }) => (
  <div data-testid={testid} style={{ background: big ? "#EFF6FF" : "#F8FAFC", border: `1px solid ${big ? "#BFDBFE" : "#E2E8F0"}`, borderRadius: 10, padding: "10px 12px" }}>
    <div style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: ".06em", textTransform: "uppercase", color: "#64748b" }}>{label}</div>
    <div style={{ fontSize: big ? 22 : 16, fontWeight: 800, color: "#0F172A", marginTop: 2 }}>{value}</div>
  </div>
);

export const fmt = (n, d = 2) => (Number.isFinite(n) ? Number(n).toLocaleString("en-IN", { maximumFractionDigits: d }) : "—");
export const sig = (n) => (!Number.isFinite(n) ? "—" : n !== 0 && Math.abs(n) < 0.01 ? Number(n.toPrecision(4)).toString() : fmt(n, 4));
export const convertVals = (obj, keys, from, to) => {
  const out = { ...obj };
  keys.forEach(k => { if (out[k] !== "") out[k] = Math.round((Number(out[k]) * UNIT_MM[from] / UNIT_MM[to]) * 1000) / 1000; });
  return out;
};

export const UNIT_MM = { mm: 1, cm: 10, in: 25.4 };
export const SHEETS = [
  ["custom", "Custom"], ["23x36in", "23 × 36 in"], ["25x36in", "25 × 36 in"], ["20x30in", "20 × 30 in"], ["28x40in", "28 × 40 in"],
  ["18x23in", "18 × 23 in"], ["22x28in", "22 × 28 in"], ["A4", "A4 (210 × 297 mm)"], ["A3", "A3 (297 × 420 mm)"], ["SRA3", "SRA3 (320 × 450 mm)"],
  ["A2", "A2 (420 × 594 mm)"], ["A1", "A1 (594 × 841 mm)"],
];
const ISO = { A4: [210, 297], A3: [297, 420], SRA3: [320, 450], A2: [420, 594], A1: [594, 841] };
export const sheetMM = (id) => {
  if (ISO[id]) return ISO[id];
  const m = /^(\d+)x(\d+)in$/.exec(id);
  return m ? [m[1] * 25.4, m[2] * 25.4] : null;
};
